import { Column } from '../../AdsetsKPIs/AdSetsTable/types'

export const COLUMNS: Column[] = [
  {
    id: 'portal',
    name: 'Portal',
  },
  {
    id: 'campaignName',
    name: 'Campaign Name',
  },
  {
    id: 'createdTime',
    name: 'Created',
  },
]
